import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdorment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import React, { useState } from 'react';

import { baseTheme } from '../../../theme';

interface IPasswordInputComponentProps {
  onChange: (event: any) => void;
  value: string;
  label: string;
  id: string;
  autoCompleteOff?: boolean | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputField: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      borderRadius: '10px',
    },
    label: {
      color: theme.palette.primary.main,
    },
  }),
);

export default function PasswordInputComponent(
  props: IPasswordInputComponentProps,
) {
  const { onChange, value, label, id, autoCompleteOff } = props;
  const classes = useStyles(baseTheme);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <InputLabel htmlFor={`filled-${id}`} className={classes.label}>{label}</InputLabel>
      <FilledInput
        id={`filled-${id}`}
        className={classes.inputField}
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        autoComplete={autoCompleteOff ? 'off' : 'on'}
        endAdornment={
          <InputAdorment position="end">
            <IconButton
              aria-label={`toggle ${id} visibility`}
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={event => event.preventDefault()}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdorment>
        }
      />
    </>
  );
}
